import { ICloudsOverviewStateService } from "./i-clouds-overview-state-service";
import { InjectionToken } from "@angular/core";

export const cloudsOverviewStateServiceInjectionToken: InjectionToken<ICloudsOverviewStateService> = new InjectionToken<ICloudsOverviewStateService>("digital-signage.user-dashboard.dashboard-web.InstalledAppsOverviewStateService");
